export default __webpack_public_path__ + "static/media/Idle (6).80b385f0.png";